
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { VerifypatientService } from 'src/app/services/verifypatient.service';
import { VerifypatientModule, PatientPersonalInfo,madisonVerification, Patient_PersonalInfo,getPatientDataByURl,madisonPatientRecord, auth } from 'src/app/models/verifypatient/verifypatient';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute,Params } from '@angular/router';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { ExitingpatientService } from 'src/app/services/exitingpatient.service';
declare var $: any;

@Component({
  selector: 'app-madisonverification',
  templateUrl: './madisonverification.component.html',
  styleUrls: ['./madisonverification.component.css']
})
export class MadisonverificationComponent implements OnInit {

  VerifypatientModule: VerifypatientModule;
  PatientPersonalInfo: PatientPersonalInfo;
  madisonpatientrecord: madisonPatientRecord = new madisonPatientRecord();
  verifyMadison : madisonVerification = new madisonVerification();
  auth : auth;
  getPatientInfo: getPatientDataByURl = new getPatientDataByURl();
  patientpersonalinfo :Patient_PersonalInfo = new Patient_PersonalInfo ();
  maxDate: any;
  isLockScreen : boolean= false;
  currentTimeZone : any;
  loginResp: any = null;
  loginRespAuth: any = null;
  curDate = new Date();
 
  constructor(private _phrutilService: PhrutillsService, private _VerifypatientService: VerifypatientService,private _login: ExitingpatientService, private spinner: NgxSpinnerService,
    private datepipe: DatePipe, private route: Router, private updateinfoservice: UpdateinfoService, private _route: ActivatedRoute) {
      this.VerifypatientModule = new VerifypatientModule();
      this.PatientPersonalInfo = new PatientPersonalInfo();
      this.auth = new auth();
    }
  profileForm = new UntypedFormGroup({
      firstName: new UntypedFormControl('', [Validators.required,Validators.minLength(1)]),
      lastName: new UntypedFormControl('', [Validators.required,Validators.minLength(1)]),
      dob: new UntypedFormControl('', [Validators.required])
    });
    
    
    ngOnInit(): void {


      this._route.queryParams.subscribe((params: Params) => {
      
        localStorage.clear();
        if (params['practice_code'] != null) {
          this.verifyMadison.practiceCode= params['practice_code'];
         // this.VerifyPractice(params['practice_code']);
        }
        else {
          $("#isNotValid_linkexiting").modal("show");
          return;
        }
      }, (error:any) => {

        localStorage.clear();
        $("#isNotValid_linkexiting").modal("show");
        return;
      });
      //localStorage.clear();
      this.getCurrentTimeZone();
    }
    getCurrentTimeZone() {
      
      let currDate = new Date().toString();
      let getOffsetwithTime = currDate.split('(');
      let offSet = getOffsetwithTime[0].substr(getOffsetwithTime[0].length - 9);
      this.currentTimeZone = offSet.trim();
      if(this.currentTimeZone.includes('+'))
      {
        let RemoveAlpht=this.currentTimeZone.split('+');
        this.currentTimeZone='+'+RemoveAlpht[1];
      }
      else if(this.currentTimeZone.includes('-'))
      {
        let RemoveAlpht=this.currentTimeZone.split('-');
        this.currentTimeZone='-'+RemoveAlpht[1];
      }
      console.log(this.currentTimeZone);
    }
    phoneLink:any;
    getPatientData(param: any) {
      
    }
    
    onSubmit() {
      // if(this.getPatientInfo.practiceCode)
      // {
      
        if (this.profileForm.valid) {
          
          this.spinner.show();
          // this.VerifypatientModule.PRACTICE_CODE = this.getPatientInfo.practiceCode.toString();
          //this.VerifypatientModule.PRACTICE_CODE = '1011163';
  
          this.verifyMadison.firstName = this.profileForm.controls['firstName'].value.trim();
          this.verifyMadison.lastName = this.profileForm.controls['lastName'].value.trim();
          this.verifyMadison.dob = this.datepipe.transform(this.profileForm.controls['dob'].value, 'MM/dd/yyyy')
          //this.verifyMadison.practiceCode = "1011163";

          this._login.VerifyExistingPatientByNameDob(this.verifyMadison.firstName,this.verifyMadison.lastName,this.verifyMadison.dob,
            this.verifyMadison.practiceCode,).subscribe((res:any)=>{
          
                    
                    if(res.statusCode==200 && res.data.status.toLowerCase()=='success')
                    {

                      this.loginResp = res.data;
                      //this.SendOTP();
          
                      this.patientpersonalinfo.DOB = this.loginResp.date_Of_Birth;
                      this.patientpersonalinfo.EMAIL_ADDRESS = this.loginResp.email_Address;
                      this.patientpersonalinfo.CELL_PHONE= this.loginResp.cell_phone;
                      this.patientpersonalinfo.FIRSTNAME= this.loginResp.first_Name;
                      this.patientpersonalinfo.LASTNAME= this.loginResp.last_Name;
                      this.patientpersonalinfo.PRACTICE_CODE= this.loginResp.practice_Code;
                      this.patientpersonalinfo.PracticeName= this.loginResp.prac_Name;
                      this.patientpersonalinfo.PATIENT_ACCOUNT= this.loginResp.patient_Account;
                      this.patientpersonalinfo.REASON_NAME= 'Madison';
                      this.patientpersonalinfo.GENDER = this.loginResp.gender;
                     // let data = this._phrutilService.encrypt(this.patientpersonalinfo);
                      let data = this._phrutilService.encrypt(this.patientpersonalinfo);
                      localStorage.setItem("AuthTokenwebServices",this.loginResp.accessTokenResponse.accessToken); 
                      localStorage.setItem("RefreashTokenwebServices",this.loginResp.accessTokenResponse.refreshToken); 
                      localStorage.setItem('PersonalInfo', data);

                        // this model is parse to next component 
                      // this.madisonpatientrecord.address = this.loginResp.address;
                      // this.madisonpatientrecord.cell_phone = this.loginResp.cell_phone;
                      // this.madisonpatientrecord.city = this.loginResp.city;
                      // this.madisonpatientrecord.date_Of_Birth = this.loginResp.date_Of_Birth;
                      // this.madisonpatientrecord.email_Address = this.loginResp.email_Address;
                      // this.madisonpatientrecord.first_Name = this.loginResp.first_Name;
                      // this.madisonpatientrecord.gender = this.loginResp.gender;
                      // this.madisonpatientrecord.last_Name = this.loginResp.last_Name;
                      // this.madisonpatientrecord.marital_Status = this.loginResp.marital_Status;
                      // this.madisonpatientrecord.patient_Account = this.loginResp.patient_Account;
                      // this.madisonpatientrecord.practice_Code = this.loginResp.practice_Code;
                      // this.madisonpatientrecord.state = this.loginResp.state;
                      // this.madisonpatientrecord.zip = this.loginResp.zip;
                      
                      this.getPatientwithoutauth();
                      
                    }
                    
                    else if(res.data.status.toLowerCase()=='no record found')
                    {  this.spinner.hide();
                      $("#incorrectinfo-model").modal("show");

                      return;
                    }
                    else if(res.data.status.toLowerCase()=='more then one patient exit with these info')
                    {
                      this.spinner.hide();
                      $("#incorrectinfo-model").modal("show");
                      return;
                    }
                  },(error:any)=>{
                    $("#incorrectinfo-model").modal("show");;
                    this.spinner.hide();
                    return;
                  });





          //   this._login.VerifyMadisonpatient(this.verifyMadison).subscribe((res: any) => {
          //   this.spinner.hide(); //Patient Details
          //   if (res && res.statusCode == 200 && res.message.toLowerCase()=='patient details') {
              
          //      this.loginResp = res.data[0];
               
          //      this.madisonpatientrecord.address = this.loginResp.address;
          //      this.madisonpatientrecord.cell_phone = this.loginResp.cell_phone;
          //      this.madisonpatientrecord.city = this.loginResp.city;
          //      this.madisonpatientrecord.date_Of_Birth = this.loginResp.date_Of_Birth;
          //      this.madisonpatientrecord.email_Address = this.loginResp.email_Address;
          //      this.madisonpatientrecord.first_Name = this.loginResp.first_Name;
          //      this.madisonpatientrecord.gender = this.loginResp.gender;
          //      this.madisonpatientrecord.last_Name = this.loginResp.last_Name;
          //      this.madisonpatientrecord.marital_Status = this.loginResp.marital_Status;
          //      this.madisonpatientrecord.patient_Account = this.loginResp.patient_Account;
          //      this.madisonpatientrecord.practice_Code = this.loginResp.practice_Code;
          //      this.madisonpatientrecord.state = this.loginResp.state;
          //      this.madisonpatientrecord.zip = this.loginResp.zip;
              

          //     // this.route.navigate(['/madison-registration'], {queryParams: {NewPatient: this.madisonpatientrecord.patient_Account}, replaceUrl: true}); 
          //   // this.route.navigateByUrl('/madison-registration');
            
          //           //  console.log("function is working")
          //             this.route.navigateByUrl("/", { skipLocationChange: true }).then(() => {
          //                 this.route.navigateByUrl("/madison-registration", { state: { unReadFaxCount: this.madisonpatientrecord} })
          //             })
          //        // }
            
    
          //   } else {
          //     $("#incorrectinfo-model").modal("show");
          //   }
          // }, (error: any) => {

          //   $("#incorrectinfo-model").modal("show");
          //   this.spinner.hide();
          // })
        }else {
          this.profileForm.markAllAsTouched();
        }
      // }else
      // {
      //   $("#linkexpire-model").modal("show");
      //   this._phrutilService.showError("Service is not available, please try later.");
      // }
      
    }
    onlyCharAllow(event: any,type:any) {
      if(event.value.trim())
      {
        let validname=event.value.replace(/[^a-zA-Z ]/g, "");
        event.value=validname;
      }
      else
      {
        event.value = event.value.trim();
        this.profileForm.controls[type].setValue(event.value);
      }    
    }

    focusOutFunction(e: any, type: any){
      // let date =  this.getloginForm.dob.value.split('-');
       // if(Number(date[0]) > this.curDate.getFullYear()){
         if((new Date(this.maxDate)) < (new Date(this.profileForm.get('dob')!.value)))
         {
        // this.getloginForm.dob.setErrors({'maxDate': true, 'invalid': true});
       }
     }

     getPatientwithoutauth(){

      //this.spinner.show();
      this._login.VerifyMadisonpatient(this.verifyMadison).subscribe((res: any) => {
        this.spinner.hide(); //Patient Details
        if (res && res.statusCode == 200 && res.message.toLowerCase()=='patient details') {
           this.loginRespAuth = res.data[0];
           
           this.madisonpatientrecord.address = this.loginRespAuth.address;
           this.madisonpatientrecord.cell_phone = this.loginRespAuth.cell_phone;
           this.madisonpatientrecord.city = this.loginRespAuth.city;
           this.madisonpatientrecord.date_Of_Birth = this.loginRespAuth.date_Of_Birth;
           this.madisonpatientrecord.email_Address = this.loginRespAuth.email_Address;
           this.madisonpatientrecord.first_Name = this.loginRespAuth.first_Name;
           this.madisonpatientrecord.gender = this.loginRespAuth.gender;
           this.madisonpatientrecord.last_Name = this.loginRespAuth.last_Name;
           this.madisonpatientrecord.marital_Status = this.loginRespAuth.marital_Status;
           this.madisonpatientrecord.patient_Account = this.loginRespAuth.patient_Account;
           this.madisonpatientrecord.practice_Code = this.loginRespAuth.practice_Code;
           this.madisonpatientrecord.state = this.loginRespAuth.state;
           this.madisonpatientrecord.zip = this.loginRespAuth.zip;
          
          // this.route.navigateByUrl("/madison-phi") 
          

                  this.route.navigateByUrl("/", { skipLocationChange: true }).then(() => {
                      this.route.navigateByUrl("/madison-registration", { state: { unReadFaxCount: this.madisonpatientrecord} })
                  })
        
        } else {
          $("#incorrectinfo-model").modal("show");
        }
      }, (error: any) => {

        $("#incorrectinfo-model").modal("show");
        this.spinner.hide();
      })
     }
}
